import React from "react";

import Checkbox from "@/ui/form/checkbox";

import type { FiltreItem } from "@/types/filtres";

import styles from "./checkbox.module.scss";

type FiltreProps = {
    item: FiltreItem;
    onChange: (item: FiltreItem) => void;
    filtersCounts: any;
    filtersSelected: Set<FiltreItem>;
};

const FiltreCheckbox = ({ item, onChange, filtersCounts, filtersSelected }: FiltreProps) => {
    const { count } = filtersCounts?.find((fc: any) => fc.id == item.id) || {
        count: 0,
    };
    const isSelected = filtersSelected.has(item);
    const itemLabel = `${item.nom}${count > 0 && !isSelected ? ` (${count})` : ""}`;

    return (
        <Checkbox
            className={styles.listeFiltreCheckbox}
            id={item.id}
            label={itemLabel}
            isSelected={isSelected}
            onChange={onChange}
            onChangeParam={item}
            enabled={count > 0}
        />
    );
};

export default FiltreCheckbox;
